webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    resetBar: function resetBar() {
      this.$store.state.bar = { search: false, exportToExcel: false, add: false, birthday: false, view: false, setting: false, refresh: false, menuinputplaceholder: '' };
      this.$store.state.heading = "";
      this.$store.state.searchTerm = "";
    },
    timer: function timer(name) {
      var start = new Date();
      var development = this.$store.state.development;
      if (development) {
        console.log('+++++++++ Timer:', name, 'started');
      }
      return {
        stop: function stop() {
          if (development) {
            var end = new Date();
            var time = end.getTime() - start.getTime();
            console.log('--------- Timer:', name, 'finished in', time, 'ms');
          }
        }
      };
    },

    sayHello: function sayHello() {
      console.log('hello from mixin!');
    }

  },
  mounted: function mounted() {
    //this.sayHello()
  }
});

// (function ($) {

//     Array.prototype.unique = function() {
//         var arr = [];
//         for(var i = 0; i < this.length; i++) {
//             if(!arr.includes(this[i])) {
//                 arr.push(this[i]);
//             }
//         }
//         return arr; 
//     }

//     function replaceUmlaute(str){
//         let mapObj = {
//             ae:"ä",
//             oe:"ö",
//             ue:"ü",
//             Ae:"Ä",
//             Oe:"Ö",
//             Ue:"Ü"
//         };
//         var re = new RegExp(Object.keys(mapObj).join("|"),"gi");
//         str = str.replace(re, function(matched){
//             return mapObj[matched];
//         });
//         return str;
//     }

//     Array.prototype.contains = function(v) {
//         for(var i = 0; i < this.length; i++) {
//             if(this[i] === v) return true;
//         }
//         return false;
//     };

// function timer(name) {
//     var start = new Date();

//     console.log('+++++++++ Timer:', name, 'started');
//     return {
//         stop: function() {
//             var end  = new Date();
//             var time = end.getTime() - start.getTime();
//             console.log('--------- Timer:', name, 'finished in', time, 'ms');
//         }
//     }
// }  

// })();

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTable_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f515a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTable_vue__ = __webpack_require__(190);
function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53f515a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f515a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {};
  },

  created: function created() {
    var element = document.getElementById("noes7").remove();
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      loginname: '',
      password: '',
      showinfo: false,
      error: false,
      msg: '',
      status: 0,
      password1: '',
      password2: '',
      view: 0,
      user_id: 0,
      user_email: ''
    };
  },

  computed: {
    classinfo: function classinfo() {
      var ReturnValue = [this.status];
      if (this.showinfo || this.error) {
        ReturnValue.push('show');
      }
      return ReturnValue;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$http.get('/api/checklogin.pl').then(function (response) {
      if (this.$route.params.regnummer > 0 && this.$route.params.user_id > 0 && response.data.user.logged_in == 1) {
        this.$http.get('/api/logout.pl').then(function (response) {
          this.$store.state.user = response.data.user;
        });
      } else if (response.data.user.logged_in == 1) {
        this.$router.push({ name: 'admin' });
        this.$router.go({ name: 'admin' });
      }
    });

    if (this.$route.params.status == "notloggedin") {
      this.showInfo('info', 'Benutzer nicht eingeloggt - Sitzung abgelaufen');
    }

    if (this.$route.params.status == "email" && this.$route.params.regnummer > 0 && this.$route.params.user_id > 0) {
      this.$http.post('/api/login.pl', { action: "email", regnummer: this.$route.params.regnummer, user_id: this.$route.params.user_id }, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        console.log(response.data);
        if (response.data.status == 1) {
          this.showInfo('info', "E-Mail '" + response.data.email + "' wurde erfolgreich bestätigt");
        } else if (response.data.status == 0) {
          this.showInfo('error', "E-Mail konnte nicht bestätigt werden");
        } else if (response.data.status == 2) {
          this.showInfo('error', "Bestätigungslink ungültig (48 Stunden)");
        }
      });
    }

    this.$nextTick(function () {
      return _this.$refs.loginname.select();
    });
  },

  methods: {
    select: function select(event) {
      console.log(event.target.select());
    },

    login: function login(event) {
      if (this.loginname.length == 0) {
        this.showInfo('error', 'Benutzer fehlt');
        return;
      }
      if (this.password.length == 0) {
        this.showInfo('error', 'Passwort fehlt');
        return;
      }
      this.$http.post('/api/login.pl', { loginname: this.loginname, password: this.password }, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        var _this2 = this;

        this.user = response.data;
        this.showinfo = false;
        if (this.user.logged_in == 1 && this.user.re_password == 1) {
          this.view = 1;
          this.user_id = this.user.user_id;
          this.$nextTick(function () {
            return _this2.$refs.password1.select();
          });
        } else if (this.user.logged_in == 1) {
          this.$router.push({ name: 'admin' });
          this.$router.go({ name: 'admin' });
        } else {
          this.showInfo('error', 'Login fehlgeschlagen');
        }
      });
    },
    passwordChange: function passwordChange(event) {
      this.$http.post('/api/login.pl', { action: "newpassword", user_id: this.user_id, password: this.password, password1: this.password1, password2: this.password2 }, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        var _this3 = this;

        console.log(response.data);
        this.showinfo = false;
        if (response.data.status == 2) {
          this.showInfo('error', 'Passwörter stimmen nicht überein');
        } else if (response.data.status == 0) {
          this.showInfo('error', 'Ein Fehler ist aufgetreten');
        } else {
          this.showInfo('info', 'Passwort wurde geändert');
          this.view = 0;
          this.$nextTick(function () {
            return _this3.$refs.loginname.select();
          });
        }
      });
    },
    forgetPasswordSend: function forgetPasswordSend(event) {
      this.$http.post('/api/login.pl', { action: "forgetPassword", user_email: this.user_email }, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
        var _this4 = this;

        this.showinfo = false;
        if (response.data.status == 2) {
          this.showInfo('error', 'Benutzer oder E-Mail nicht gefunden');
        } else if (response.data.status == 0) {
          this.showInfo('error', 'Ein Fehler ist aufgetreten');
        } else {
          this.showInfo('info', 'Es wurde eine E-Mail gesendet');
          this.view = 0;
          this.$nextTick(function () {
            return _this4.$refs.loginname.select();
          });
        }
      });
    },
    forgetPassword: function forgetPassword(event) {
      var _this5 = this;

      this.showinfo = false;
      this.view = 2;
      this.$nextTick(function () {
        return _this5.$refs.user_email.select();
      });
    },
    keyup: function keyup(event) {
      if (this.error) {
        this.error = false;
        this.msg = '';
      }
    },
    showInfo: function showInfo(status, msg) {
      if (this.status == 'error') {
        this.error = true;
      }
      this.showinfo = true;
      this.status = status;
      this.msg = msg;
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(170);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'admin',
  data: function data() {
    return {
      firstloaded: 0,
      infoText: "",
      infoTextList: [],
      infoStyle: "",
      infoShow: false,
      timeoutHandle: null
    };
  },

  computed: {
    classinfoStyle: function classinfoStyle() {
      return [this.infoStyle, this.infoShow ? 'show' : 'hide'];
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$store.state.heading = "TSV Kunreuth Adminbereich";
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("logout", function () {
      _this.$http.get('/api/logout.pl').then(function (response) {
        this.$store.state.user = response.data.user;
        if (this.$store.state.user.logged_in == 0) {
          this.$router.push({ name: 'login' });
        }
      });
    });
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("checklogin", function () {
      if (_this.infoShow) {
        window.clearTimeout(_this.timeoutHandle);
        _this.infoShow = false;
      }
      _this.$http.get('/api/checklogin.pl').then(function (response) {
        if (this.$store.state.user.logged_in == 1 && response.data.user.logged_in == 0) {
          this.$store.state.user = response.data.user;
          this.$router.push({ name: 'loginstatus', params: { status: "notloggedin" } });
        } else if (response.data.user.logged_in == 0) {
          this.$store.state.user = response.data.user;
          this.$router.push({ name: 'login' });
        }
        this.$store.state.user = response.data.user;
      });
    });

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("hideinfo", function (style, errorText, time) {
      if (_this.infoShow) {
        window.clearTimeout(_this.timeoutHandle);
        _this.infoShow = false;
      }
    });

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("showinfo", function (style, errorText, time) {
      if (style === '') {
        return;
      }
      if (_this.infoShow) {
        window.clearTimeout(_this.timeoutHandle);
        _this.infoShow = false;
      }
      _this.infoStyle = style;
      if (Array.isArray(errorText)) {
        _this.infoTextList = errorText;
      } else {
        _this.infoText = errorText;
        _this.infoTextList = [];
      }
      _this.infoShow = true;
      if (time > 0) {
        var self = _this;
        var t = time * 1000;
        _this.timeoutHandle = setTimeout(function () {
          self.infoShow = false;
        }, t);
      }
    });

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
  },
  updated: function updated() {
    this.$nextTick(function () {
      if (this.firstloaded == 0) {
        this.firstloaded = 1;
      }
    });
  },
  methods: {
    closeInfoShow: function closeInfoShow(event) {
      this.infoShow = false;
    }
  },
  components: {
    JHMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu__["a" /* default */]
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "jhmenu",
  data: function data() {
    return {
      status: 0,
      menuinput: ''
    };
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("resetMenuInput", function (item) {
      _this.menuinput = '';
    });
  },
  updated: function updated() {},
  computed: {
    classLeftBar: function classLeftBar() {
      return {
        leftbar: true,
        close: this.status == 0,
        open: this.status == 1
      };
    },
    shortProfilName: function shortProfilName() {
      var returnValue = "";
      if (this.$store.state.user.prename.length > 0) {
        returnValue += this.$store.state.user.prename[0];
      }
      if (this.$store.state.user.familyname.length > 0) {
        returnValue += this.$store.state.user.familyname[0];
      }
      return returnValue;
    }
  },
  methods: {
    switchShow: function switchShow() {
      if (this.status == 0) {
        this.status = 1;
      } else {
        this.status = 0;
      }
    },
    mouseOverLeftBar: function mouseOverLeftBar() {
      this.status = 1;
    },
    mouseLeaveLeftBar: function mouseLeaveLeftBar() {
      this.status = 0;
    },
    clicked: function clicked(eventName, item) {
      __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit(eventName, item);
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_functions__["a" /* default */]],
  data: function data() {
    return {
      result: [],
      settings: { rowMax: 25, searchinput: false },
      fields: [{ label: "Anrede", show: "salutation", width: "65px" }, { label: "Vorname", show: "prename" }, { label: "Nachname", show: "familyname" }, { label: "Geschlecht", show: "geschlecht", width: "100px", classes: ["center", "icon"], hclasses: ["center"], iconcolname: "geschlecht_icon" }, { label: "PLZ", show: "plz", width: "80px", classes: ["center"], hclasses: ["center"] }, { label: "Ort", show: "ort", width: "300px" },
      // { label: "Anzahl SN an RouteSteps", show: "sn_not_finished_quantity", classes: ["center"], hclasses: ["center"]},
      // { label: "F-Planer", show: "qplaner_name", width: "100px", classes: ["ellipsis"]},
      // { label: "P-Planer", show: "planer_name", width: "100px", classes: ["ellipsis"]},
      { label: "Geburtstag", show: "geburtstag", width: "100px", sort: "geburtstag_sort", type: "datetime" }, { label: "", show: "Mitglied löschen", type: "button", event: "deleteMember", classes: ["center", "button", "img-delete"] }, { label: "", show: "Mitglied editieren", type: "button", event: "editMember", classes: ["center", "button", "img-edit"] }]
    };
  },

  created: function created() {
    this.resetBar();
    this.$store.state.bar.search = true;
    this.$store.state.bar.exportToExcel = true;
    this.$store.state.bar.add = true;
    this.$store.state.bar.birthday = true;
    this.$store.state.bar.view = true;
    this.$store.state.bar.setting = true;

    this.$store.state.isLoading = true;
    this.$store.state.heading = "Mitgliederübersicht";
    this.$http.get('/api/get_member.pl').then(function (response) {
      console.log(response.data);
      this.result = response.data.member;
      this.$store.state.isLoading = false;
      response.data.dberror ? __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined;
    });
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("deleteMember", function (item) {});
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("editMember", function (item) {
      _this.$router.push({ name: 'editMember', params: { member_id: item.member_id } });
    });
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("add", function (item) {
      _this.$router.push({ name: 'newMember' });
    });
  },
  components: {
    BaseTable: __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__["a" /* default */]
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BaseTablePagination__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_functions__ = __webpack_require__(8);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BaseTable',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_functions__["a" /* default */]],
  props: {
    settings: { type: Object },
    fields: { type: Array, default: function _default() {
        return [];
      } },
    items: { type: Array, default: function _default() {
        return [];
      } },
    sortBy: { type: String, default: '' },
    sortOrder: { type: String, default: '' },
    searchTerm: { type: String, default: '' },
    rowClass: { type: String, default: '' },
    tableClass: { type: String, default: '' },
    striped: { type: Boolean, default: true },
    bordered: { type: Boolean, default: true },
    colstripes: { type: Boolean, default: false },
    outlined: { type: Boolean, default: true },
    hover: { type: Boolean, default: true },
    tableId: { type: String, default: "1" }
  },
  data: function data() {
    return {
      sortedItems: [],
      columns: [],
      rows: [],
      filter: '',
      sort: {
        fieldName: '',
        order: ''
      },
      searchTermIntern: '',
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        rowMax: 0
      }
    };
  },
  created: function created() {
    var t = this.timer("created BaseTable");
    this.sort.fieldName = this.sortBy;
    this.sort.order = this.sortOrder;
    this.searchTermIntern = this.searchTerm;
    if (this.settings.rowMax && this.settings.rowMax > 0) {
      this.pagination.rowMax = this.settings.rowMax;
    }
    this.readUrl();
  },
  mounted: function mounted() {
    var _this = this;

    var t = this.timer("mounted");
    __WEBPACK_IMPORTED_MODULE_2__bus__["a" /* default */].$on("resetFilterClicked", function () {
      _this.searchTermIntern = "";
    });
    t.stop();
  },

  computed: {
    displayedFields: function displayedFields() {
      var t = this.timer("displayedFields");
      var fields = [];
      if (this.fields && this.fields.length > 0) {
        fields = this.fields;
        return fields;
      }
      if ((!fields || fields.length == 0) && this.items && this.items.length > 0) {
        fields = [];
        for (var show in this.items[0]) {
          if (!show.endsWith("_c")) {
            var col = {};
            col.label = convertHeaderName(show);
            col.show = show;
            fields.push(col);
          }
        }
      }
      t.stop();
      return fields;
    },
    tableClasses: function tableClasses() {
      return ['table', 'reportTable', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', this.colstripes ? 'colstripes' : '', this.tableClass];
    },
    wrapTableClasses: function wrapTableClasses() {
      return ['reportTableWrap', this.bordered ? 'test' : 'table-not-bordered'];
    },
    displayedRows: function displayedRows() {
      var t = this.timer("displayedRows");
      //this.setFilter();
      if (this.pagination.rowMax > 0) {
        t.stop();
        var start = (this.pagination.currentPage - 1) * this.pagination.rowMax;
        var end = this.pagination.rowMax * this.pagination.currentPage;
        return this.sortedItems.slice(start, end);
      }
      t.stop();
      return this.sortedItems;
    }
  },
  methods: {
    colclasses: function colclasses(field, row) {
      var returnValue = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], field.classes);
      if (typeof field.colclass != 'undefined') {
        returnValue.push(row[field.colclass]);
      }
      return returnValue;
    },
    hasClass: function hasClass(cc, c) {
      return Array.isArray(cc) && cc.find(function (x) {
        return x === c;
      });
    },

    test: function test() {

      console.log(this.fields);
      console.log(this.rows);
    },
    clicked: function clicked(eventName, item, item2) {
      __WEBPACK_IMPORTED_MODULE_2__bus__["a" /* default */].$emit(eventName, item, item2);
    },
    pageChange: function pageChange(page) {
      this.pagination.currentPage = page;
      this.updateUrl();
    },

    UpdatePagination: function UpdatePagination() {
      if (this.pagination.rowMax > 0) {
        this.pagination.totalPages = Math.ceil(this.sortedItems.length / this.pagination.rowMax);
      }
      this.pagination.totalItems = this.sortedItems.length;
    },
    setFilter: function setFilter() {
      var t = this.timer("setFilter");
      var s = this.searchTermIntern.toUpperCase();
      var f = this.fields;
      this.pagination.currentPage = 1;

      var tmp = this.rows.filter(function (item) {
        var found = true;
        f.forEach(function (field) {
          if (item[field.show]) {
            if (field.isFiltered) {
              if (field.notSelected.includes(item[field.show])) {
                found = false;
                return;
              }
            }
          }
        });
        return found;
      });

      this.sortedItems = tmp.filter(function (item) {
        var found = false;
        f.forEach(function (field) {
          if (field.type == "info" || field.type == "check" || field.type == "button") {
            return;
          }
          if (item[field.show]) {
            if (item[field.show].toString().toUpperCase().indexOf(s) > -1) {
              found = true;
              return;
            }
          }
        });
        return found;
      });
      this.UpdatePagination();
      this.updateUrl();
      t.stop();
    },
    highlight: function highlight(word, query) {
      var check = new RegExp(query, "ig");
      return word.toString().replace(check, function (matchedText, a, b) {
        return '<span style="color:#c90000">' + matchedText + "</span>";
      });
    },

    orderBy: function orderBy(field) {
      var t = this.timer("orderBy");
      if (this.isFieldSortable(field.show)) {
        if (this.sort.fieldName === field.show) {
          this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
        } else {
          this.sort.order = "desc";
          this.sort.fieldName = field.show;
        }

        this.pagination.currentPage = 1;

        var sf = field.sort && field.sort.length > 0 ? field.sort : this.sort.fieldName + "_c";
        var sort_asc = this.sort.order === "asc" ? 1 : 0;

        this.sortedItems.sort(function (a, b) {
          var tmp_a = a[sf];
          var tmp_b = b[sf];
          if (tmp_a === tmp_b) {
            return 0;
          } else {
            if (tmp_a == parseInt(tmp_a, 10) && tmp_b == parseInt(tmp_b, 10)) {
              tmp_a = parseInt(tmp_a, 10);
              tmp_b = parseInt(tmp_b, 10);
            }
            if (sort_asc == 1) {
              return tmp_a < tmp_b ? -1 : 1;
            } else {
              return tmp_a > tmp_b ? -1 : 1;
            }
            //return sort_bool(tmp_a , tmp_b, sort_asc);    
          }
        });
        this.updateUrl();
        t.stop();
      }
    },
    isFieldSortable: function isFieldSortable(field) {
      var foundHeader = this.fields.find(function (item) {
        return item.show === field;
      });
      return foundHeader;
    },
    readUrl: function readUrl() {
      var t = this.timer("readUrl");
      if (this.$route.query["t" + this.tableId + "p"]) {
        var pageurl = parseInt(this.$route.query["t" + this.tableId + "p"]);
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(pageurl)) {
          this.pagination.currentPage = pageurl;
        }
      }
      if (this.$route.query["t" + this.tableId + "sfn"]) {
        this.sort.fieldName = this.$route.query["t" + this.tableId + "sfn"];
        this.sort.order = this.$route.query["t" + this.tableId + "sfo"];
      }

      if (this.$route.query["t" + this.tableId + "searchTerm"]) {
        this.searchTermIntern = this.$route.query["t" + this.tableId + "searchTerm"];
      }
      t.stop();
    },
    updateUrl: function updateUrl() {
      var t = this.timer("updateUrl");
      var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);

      query["t" + this.tableId + "p"] = this.pagination.currentPage;
      query["t" + this.tableId + "sfn"] = this.sort.fieldName;
      query["t" + this.tableId + "sfo"] = this.sort.order;

      if (this.searchTermIntern.length > 0 && this.searchTermIntern != this.searchTerm) {
        query["t" + this.tableId + "searchTerm"] = this.searchTermIntern;
      } else {
        delete query["t" + this.tableId + "searchTerm"];
      }

      this.$router.replace({ query: query }).catch(function (err) {});
      t.stop();
    }
  },
  watch: {
    filter: function filter(d) {
      var t = this.timer("watch filter");
      t.stop();
    },
    searchTerm: function searchTerm() {
      var t = this.timer("watch searchTerm");
      this.searchTermIntern = this.searchTerm;
      t.stop();
    },
    searchTermIntern: function searchTermIntern() {
      var t = this.timer("watch searchTermIntern");
      this.setFilter();
      t.stop();
    },
    items: function items() {
      var t = this.timer("watch items");
      this.sortedItems = this.items.slice(0);
      this.rows = this.items.slice(0);

      this.UpdatePagination();
      var func = function func(i, f) {
        i.forEach(function (item, num, index) {
          f.forEach(function (field) {
            if (item[field.show]) {
              // + c für compare bei orderby, falls eine suche aktiv ist und der text ein span vom highlight hat.
              item[field.show + '_c'] = item[field.show].toString().toLowerCase();

              item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00e4/g, "ae");
              item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00f6/g, "oe");
              item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00fc/g, "ue");
            } else {
              item[field.show + '_c'] = '';
            }
          });
        });
      };

      this.setFilter();
      t.stop();
      func(this.items, this.fields);
      t.stop();
    }
  },
  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_3__BaseTablePagination__["a" /* default */]
  }
});

function remove_first_character(element) {
  return element.slice(1);
}

function wrapInTag(opts) {
  var tag = opts.tag || 'strong',
      words = opts.words || [],
      regex = RegExp(words.join('|'), 'gi'),
      replacement = '<' + tag + '>$&</' + tag + '>';
}
function sort_bool(a, b, sort_asc) {
  if (a == parseInt(a, 10) && b == parseInt(b, 10)) {
    a = parseInt(a, 10);
    b = parseInt(b, 10);
  }
  if (sort_asc == 1) {
    return a < b ? -1 : 1;
  } else {
    return a > b ? -1 : 1;
  }
}

function convertHeaderName(show) {
  var words = show.split('_');
  words.forEach(function (num, index) {
    return words[index] = words[index].charAt(0).toUpperCase() + words[index].slice(1);
  });
  return words.join(' ');
}

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        pagination: {
            type: Object,
            default: function _default() {
                return {};
            }
        }
    },
    data: function data() {
        return {
            timer: {},
            plusMinus: ''
        };
    },
    mounted: function mounted() {
        //console.log(this.pagination);
    },

    computed: {
        pages: function pages() {
            return this.pagination.totalPages === undefined ? [] : this.pageLinks();
        },
        von: function von() {
            return this.pagination.rowMax * (this.pagination.currentPage - 1) + 1;
        },
        bis: function bis() {
            return this.pagination.currentPage * this.pagination.rowMax > this.pagination.totalItems ? this.pagination.totalItems : this.pagination.currentPage * this.pagination.rowMax;
        },
        hasFirst: function hasFirst() {
            return this.pagination.currentPage >= 4 || this.pagination.totalPages < 7;
        },
        hasLast: function hasLast() {
            return this.pagination.currentPage <= this.pagination.totalPages - 3 || this.pagination.totalPages < 7;
        },
        hasFirstEllipsis: function hasFirstEllipsis() {
            return this.pagination.currentPage >= 4 && this.pagination.totalPages >= 7;
        },
        hasLastEllipsis: function hasLastEllipsis() {
            return this.pagination.currentPage <= this.pagination.totalPages - 3 && this.pagination.totalPages >= 7;
        },
        shouldShowPagination: function shouldShowPagination() {
            if (this.pagination.totalPages === undefined) {
                return false;
            }

            if (this.pagination.count === 0) {
                return false;
            }

            return this.pagination.totalPages > 1;
        }
    },

    methods: {
        isActive: function isActive(page) {
            var currentPage = this.pagination.currentPage || 1;

            return currentPage === page;
        },
        pageClicked: function pageClicked(page) {
            if (page === '...' || page === this.pagination.currentPage || page > this.pagination.totalPages || page < 1) {
                return;
            }

            this.$emit('pageChange', page);
        },
        pageLinks: function pageLinks() {
            var pages = [];

            var left = 2;
            var right = this.pagination.totalPages - 1;

            if (this.pagination.totalPages >= 7) {
                left = Math.max(1, this.pagination.currentPage - 2);
                right = Math.min(this.pagination.currentPage + 2, this.pagination.totalPages);
            }

            for (var i = left; i <= right; i++) {
                pages.push(i);
            }

            return pages;
        },
        pageMouseDown: function pageMouseDown(plusMinus) {
            this.plusMinus = plusMinus;
            this.timer = setInterval(this.nextStep, 100);
        },
        pageMouseUp: function pageMouseUp() {
            clearInterval(this.timer);
        },

        nextStep: function nextStep() {
            if (this.plusMinus === '-') {
                if (this.pagination.currentPage > 1) {
                    this.pagination.currentPage--;
                    this.$emit('pageChange', this.pagination.currentPage);
                } else {
                    clearInterval(this.timer);
                }
            } else if (this.plusMinus === '+') {
                if (this.pagination.currentPage < this.pagination.totalPages) {
                    this.pagination.currentPage++;
                    this.$emit('pageChange', this.pagination.currentPage);
                } else {
                    clearInterval(this.timer);
                }
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        clearInterval(this.timer);
    }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'membereditnew',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_functions__["a" /* default */]],
  props: {
    member: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      memberSelectedMulti: [{ value: 3, text: "test" }],
      lastSelectItem: {}
    };
  },

  created: function created() {
    this.resetBar();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    if (this.$route.params.member_id < 0) {
      this.$store.state.heading = "Mitglied editieren";
      this.$store.state.isLoading = true;
      console.log(this.$route.params.member_id);
      this.$http.get('/api/get_member.pl', { params: { member_id: this.$route.params.member_id } }).then(function (response) {
        this.result = response.data.member;
        console.log(response.data);
        this.$store.state.isLoading = false;
      });
    } else {
      this.$store.state.heading = "Mitglied hinzufügen";
    }
  },
  methods: {},
  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_table_BaseTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_functions__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'smsservice',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_functions__["a" /* default */]],
  data: function data() {
    return {
      anmeldungen_anzahl: 0,
      active: 0,
      abteilung: '-1',
      smscontent: '',
      smscontentarray: [],
      maxchars: 160,
      anzahlzeichen: '',
      sms_anmeldungen: [],
      settings_anmeldungen: { rowMax: 17 },
      fields_anmeldungen: [{ label: "Name", show: "name", classes: ["nowrap"], width: "200px" }, { label: "Mobil", show: "number" }, { label: "Aktiv", show: "active", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Abt. Fußball", show: "fussball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Abt. Tennis", show: "tennis", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Abt. Gymnastik", show: "gym", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Abt. Volleyball", show: "vollyball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil Rund-SMS", show: "send_news", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil an Alle", show: "send_all", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil an Abt. Fußball", show: "send_fussball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil an Abt. Tennis", show: "send_tennis", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil an Abt. Gymnastik", show: "send_gym", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Von Mobil an Abt. Volleyball", show: "send_vollyball", classes: ["center", "nowrap", "button"], hclasses: ["rotate"], width: "60px", type: "check", event: "changeCheck" }, { label: "Start", show: "start", sort: "start_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"] }],
      sms_gesendet: [],
      settings_gesendet: { rowMax: 20 },
      fields_gesendet: [{ label: "Von", show: "von", classes: ["nowrap"], width: "150px" }, { label: "Mobil", show: "number", width: "155px" }, { label: "Web / Bot", show: "bot_web_desc", width: "50px", classes: ["center", "nowrap"], hclasses: ["nowrap"] }, { label: "SMS Inhalt", show: "content", classes: ["nowrap", "ellipsis"] }, { label: "Empfänger", show: "anzahl_empfaenger", title: "empfaenger", classes: ["center", "nowrap"], hclasses: ["nowrap"], width: "50px", type: "title" }, { label: "An Alle", show: "all", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check" }, { label: "An Abt. Fußball", show: "fussball", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check" }, { label: "An Abt. Tennis", show: "tennis", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check" }, { label: "An Abt. Gymnastik", show: "gym", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check" }, { label: "An Abt. Volleyball", show: "vollyball", classes: ["center", "nowrap", "icon"], hclasses: ["rotate"], width: "60px", type: "check" }, { label: "Gesendet", show: "send_datetime", sort: "send_datetime_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"] }],
      sms_empfangen: [],
      settings_empfangen: { rowMax: 20 },
      fields_empfangen: [{ label: "Von", show: "from_sms_service_id", classes: ["nowrap"], width: "150px" }, { label: "Mobil", show: "number", width: "155px" }, { label: "SMS Inhalt", show: "content", classes: ["nowrap", "ellipsis"], hclasses: ["nowrap"] }, { label: "Empfangen", show: "receive_datetime", sort: "receive_datetime_sort", width: "155px", type: "datetime", classes: ["center", "nowrap"], hclasses: ["center"] }],

      load: { anmeldungen: false, sms_send: false }
    };
  },

  created: function created() {
    this.resetBar();
    this.initData();
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("checklogin");
    this.$store.state.heading = "SMS Service";

    this.$nextTick(function () {
      return _this.$refs.smstextarea.select();
    });

    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on("refresh", function (item, h) {
      if (_this.active == 1) {
        _this.refreshContent('sms_anmeldungen');
      } else if (_this.active == 2) {
        _this.refreshContent('sms_gesendet');
      } else if (_this.active == 3) {
        _this.refreshContent('sms_empfangen');
      }
    });

    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on("changeCheck", function (item, h) {

      if (h.show == "send_all" || h.show == "send_fussball" || h.show == "send_tennis" || h.show == "send_gym" || h.show == "send_vollyball") {
        var old_state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
        item.send_all = 2;
        item.send_fussball = 2;
        item.send_tennis = 2;
        item.send_gym = 2;
        item.send_vollyball = 2;

        var headers = { 'Content-Type': 'application/json' };
        _this.$http.post('/api/sms.pl', { action: "setAnmeldungRadio", sms_service_id: item.sms_service_id, what: h.show, item: item }, { headers: headers }).then(function (response) {
          var result = response.data;
          if (result.status == 1) {
            item.send_all = response.data.item.send_all;
            item.send_fussball = response.data.item.send_fussball;
            item.send_tennis = response.data.item.send_tennis;
            item.send_gym = response.data.item.send_gym;
            item.send_vollyball = response.data.item.send_vollyball;

            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("checklogin");
          } else if (result.status == 2) {
            item.send_all = old_state.send_all;
            item.send_fussball = old_state.send_fussball;
            item.send_tennis = old_state.send_tennis;
            item.send_gym = old_state.send_gym;
            item.send_vollyball = old_state.send_vollyball;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", response.data.error, 10);
          } else {
            item.send_all = old_state.send_all;
            item.send_fussball = old_state.send_fussball;
            item.send_tennis = old_state.send_tennis;
            item.send_gym = old_state.send_gym;
            item.send_vollyball = old_state.send_vollyball;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10);
          }
        });
      } else {
        var old_state = item[h.show];
        item[h.show] = 2;
        var _headers = { 'Content-Type': 'application/json' };
        _this.$http.post('/api/sms.pl', { action: "setAnmeldung", sms_service_id: item.sms_service_id, what: h.show }, { headers: _headers }).then(function (response) {
          var result = response.data;
          if (result.status == 1) {
            item[h.show] = response.data.new_state;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("checklogin");
          } else if (result.status == 2) {
            item[h.show] = old_state;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", response.data.error, 10);
          } else {
            item[h.show] = old_state;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10);
          }
        });
      }
    });

    if (!this.$route.params.page_sms) {
      this.$router.push({ name: 'smsservice', params: { page_sms: 0 } }).catch(function (err) {});
    }
    this.active = this.$route.params.page_sms;
    this.$store.state.bar.search = this.active == 0 ? false : true;
    this.$store.state.bar.refresh = this.active == 0 ? false : true;
  },
  computed: {
    menuDescAnmeldungen: function menuDescAnmeldungen() {
      return "Anmeldungen ( " + this.anmeldungen_anzahl + " )";
    }
  },
  methods: {
    smssend: function smssend(event) {
      __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("hideinfo");

      if (this.abteilung == '-1') {
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "An wen soll die SMS verschickt werden? Bitte eine Auswahl treffen!", 10);
        return;
      }
      console.log(this.smscontentarray.length);
      if (this.smscontentarray.length == 0 || this.smscontentarray.length > 0 && this.smscontentarray[0].length <= 20) {
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "info", "SMS muss mindestens 20 Zeichen haben", 10);
        return;
      }

      if (this.$store.state.user.permissions.sms_send_all) {
        var headers = { 'Content-Type': 'application/json' };
        console.log(document.cookie);
        this.$http.post(this.$store.state.user.send_sms_url, { abteilung: this.abteilung, content: this.smscontentarray, c: document.cookie }, { headers: headers, useCredentails: true }).then(function (response) {
          var result = response.data;
          if (result.status == 0) {
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", result.error, 10);
          } else if (result.status == 2) {
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "info", result.info, 5);
          } else {
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "success", "SMS's wurden erfolgreich gesendet", 4);
            this.smscontent = "";
          }
        }, function (response) {
          //error
          __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Es ist ein Fehler mit der Schnittstelle aufgetreten. Bitte den Webmaster kontaktieren.", 10);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Keine Berechtigung SMS zu versenden", 10);
      }
    },
    // sms_anmeldungen_count(){
    //   this.$http.get('/api/getData.pl', {params:  {data: ['sms_anmeldungen_count']}}).then(function (response) {
    //     this.anmeldungen_anzahl = response.data.sms_anmeldungen_count
    //     this.$store.state.isLoading = false
    //   });
    // },
    get_all_data: function get_all_data() {
      this.$http.get('/api/getData.pl', { params: { data: ['sms_anmeldungen', 'sms_gesendet', 'sms_empfangen'] } }).then(function (response) {
        this.sms_anmeldungen = response.data.sms_anmeldungen;
        this.sms_gesendet = response.data.sms_gesendet;
        this.sms_empfangen = response.data.sms_empfangen;
        this.anmeldungen_anzahl = this.sms_anmeldungen.length;
        this.load.anmeldungen = true;
        this.load.sms_send = true;
        this.checkLoadAll();
      });
    },
    initData: function initData() {
      this.$store.state.isLoading = true;
      if (this.$store.state.user.permissions.sms_send_all) {
        this.abteilung = '0';
      } else if (this.$store.state.user.permissions.sms_send_fussball) {
        this.abteilung = '1';
      } else if (this.$store.state.user.permissions.sms_send_tennis) {
        this.abteilung = '2';
      } else if (this.$store.state.user.permissions.sms_send_vollyball) {
        this.abteilung = '3';
      } else if (this.$store.state.user.permissions.sms_send_gym) {
        this.abteilung = '4';
      }
      this.get_all_data();
    },
    checkLoadAll: function checkLoadAll() {
      if (this.load.anmeldungen && this.load.sms_send) {
        this.$store.state.isLoading = false;
      }
    },
    getSmsContent: function getSmsContent(content, maxchars) {

      if (content.length > maxchars) {

        // holt die erste x Zeichen aus dem string und split mit leerzeichen - array von Wörter zurück
        var textarray = content.trim().substring(0, maxchars).split(" ");

        // nimmt alle wörter außer das letzte Wort und joint die leerzeichen wieder
        var smstext = textarray.slice(0, -1).join(" ");

        // nimmt das letzte Wort aus dem Array
        var restsmstext = textarray.slice(textarray.length - 1, textarray.length).join(" ");

        // das letzte Wort und der rest vom string wird zusammengeführt. Für die nächste Überprüfung
        var resttext = restsmstext + content.trim().substring(maxchars, content.length);

        // push die SMS in content array
        this.smscontentarray.push(smstext);

        this.getSmsContent(resttext, maxchars);
      } else if (content.length > 0) {
        var regex = /\w+/gm;
        var match = regex.exec(content);
        if (match) {
          this.smscontentarray.push(content);
        }
      }
    },
    refreshContent: function refreshContent(what) {
      this.$store.state.isLoading = true;
      this.$http.get('/api/getData.pl', { params: { data: [what] } }).then(function (response) {
        if (what == 'sms_anmeldungen') {
          this.sms_anmeldungen = response.data.sms_anmeldungen;
          this.anmeldungen_anzahl = this.sms_anmeldungen.length;
        } else if (what == 'sms_gesendet') {
          this.sms_gesendet = response.data.sms_gesendet;
        } else if (what == 'sms_empfangen') {
          this.sms_empfangen = response.data.sms_empfangen;
        }
        this.$store.state.isLoading = false;
      });
    }
  },
  watch: {
    smscontent: function smscontent() {
      this.smscontentarray = [];
      var countchars = this.smscontent.length;
      var smscount = Math.floor(countchars / this.maxchars) + 1;
      if (smscount > 1) {
        this.anzahlzeichen = countchars + " (SMS: " + smscount + ")";
      } else {
        this.anzahlzeichen = countchars;
        this.smscontentarray.push(this.smscontent);
      }

      this.smscontentarray = [];
      this.getSmsContent(this.smscontent, this.maxchars);
    },
    '$route': function $route(to, from) {
      if (!this.$route.params.page_sms) {
        this.$router.push({ name: 'smsservice', params: { page_sms: 0 } }).catch(function (err) {});
      }
      this.active = this.$route.params.page_sms;
      this.$store.state.bar.search = this.active == 0 ? false : true;
      this.$store.state.bar.refresh = this.active == 0 ? false : true;
    }
  },
  components: {
    BaseTable: __WEBPACK_IMPORTED_MODULE_2__components_table_BaseTable__["a" /* default */]
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'docs',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_functions__["a" /* default */]],
  data: function data() {
    return {};
  },

  created: function created() {
    this.resetBar();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    this.$store.state.heading = "Dokumente";
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_functions__["a" /* default */]],
  data: function data() {
    return {
      result: [],
      settings: { rowMax: 25, searchinput: false },
      fields: [{ label: "Loginname", show: "loginname" }, { label: "Vorname", show: "prename" }, { label: "Nachname", show: "familyname" }, { label: "E-Mail", show: "email" }, { label: "Registrierungsdatum", show: "regdate", classes: ["center", "nowrap"], hclasses: ["center"], width: "150px", sort: "regdate_sort", type: "datetime" }, { label: "Letzter Besuch", show: "lastonline", classes: ["center", "nowrap"], hclasses: ["center"], width: "100px", sort: "lastonline_sort", type: "datetime" }, { label: "", show: "Benutzer löschen", type: "button", event: "deleteUser", classes: ["center", "button", "img-delete"] }, { label: "", show: "Benutzer editieren", type: "button", event: "editUser", classes: ["center", "button", "img-edit"] }]
    };
  },

  created: function created() {
    this.resetBar();
    this.$store.state.bar.search = true;

    if (this.$store.state.user.permissions.generally_export_data) {
      this.$store.state.bar.exportToExcel = true;
    }
    if (this.$store.state.user.permissions.user_add) {
      this.$store.state.bar.add = true;
    }

    //this.$store.state.bar.view = true
    //this.$store.state.bar.setting = true

    this.$store.state.isLoading = true;
    this.$store.state.heading = "Benutzerübersicht";
    this.$http.get('/api/get_user.pl').then(function (response) {
      console.log(response.data);
      this.result = response.data.users;
      this.$store.state.isLoading = false;
      response.data.dberror.hasError ? __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined;
      __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", response.data.callmessage, response.data.message, response.data.timesecmessage);
    });
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("deleteUser", function (item) {});
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("editUser", function (item) {
      _this.$router.push({ name: 'editUser', params: { user_id: item.user_id } });
    });
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("add", function (item) {
      _this.$router.push({ name: 'newUser' });
    });
  },
  components: {
    BaseTable: __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__["a" /* default */]
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_functions__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_validation__ = __webpack_require__(210);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'usereditnew',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_functions__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_validation__["a" /* default */]],
  props: {
    member: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      optionsMember: [],
      selectedMember: 0,
      loadMember: true,
      optionsSecurity: [],
      selectedSecurity: 0,
      loadSecurity: true, // 0 = wird nicht geändert / 1 = wird generiert / 2 = wird eingegeben
      currentUser: { user_id: 0,
        member_id: 0,
        security_group: 0,
        passwordStatus: 0,
        loginname: '',
        email: '',
        userprename: '',
        prename: '',
        userfamilyname: '',
        familyname: ''
      },
      validation: {
        loginname: { type: 'minLength[3]', prompt: 'Benutzername muss mindestens 3 Zeichen lang sein' },
        email: { type: 'email', prompt: 'E-Mail Adresse ist keine gültige E-Mail', promptEmpty: 'E-Mail Adresse ist ein Pflichtfeld' },
        password: { type: 'minLength[6]password', compareField: 'password_wdh', prompt: 'Passwort muss mindestens 6 Zeichen lang sein', prompt2: 'Eingebene Passwörter stimmen nicht überein' },
        security_group: { type: 'selectionNot0', prompt: 'Auswahl Benutzergruppe fehlt' }
      },
      users: [],
      showformular: true
    };
  },

  computed: {
    prename: {
      get: function get() {
        var _this = this;

        if (this.currentUser.member_id > 0) {
          return this.optionsMember.find(function (x) {
            return x.value === _this.currentUser.member_id;
          }).prename;
        } else {
          return this.currentUser.userprename;
        }
      },
      set: function set(value) {
        this.currentUser.prename = value;
        this.currentUser.userprename = value;
      }
    },
    familyname: {
      get: function get() {
        var _this2 = this;

        if (this.currentUser.member_id > 0) {
          return this.optionsMember.find(function (x) {
            return x.value === _this2.currentUser.member_id;
          }).familyname;
        } else {
          return this.currentUser.userfamilyname;
        }
      },
      set: function set(value) {
        this.currentUser.familyname = value;
        this.currentUser.userfamilyname = value;
      }

    },
    prenameFamilynameClass: function prenameFamilynameClass() {
      return this.currentUser.member_id > 0 ? "disabled" : "";
    },
    Checkreadonly: function Checkreadonly() {
      return this.currentUser.member_id > 0 ? true : false;
    }
  },
  created: function created() {
    this.resetBar();
    if (this.$store.state.user.permissions.user_add) {
      this.$store.state.bar.add = true;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.infoShow = false;
    this.resetValues();
    this.loadInit();

    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on("add", function (item) {
      _this3.resetValues();
      _this3.currentUser.passwordStatus = 1;
      _this3.$router.push({ name: 'newUser' }).catch(function (err) {});
      _this3.$nextTick(function () {
        return _this3.$refs.loginname.select();
      });
    });
  },
  methods: {
    resetValues: function resetValues() {
      this.currentUser = { user_id: 0,
        member_id: 0,
        security_group: 0,
        passwordStatus: 0,
        loginname: '',
        email: '',
        userprename: '',
        prename: '',
        userfamilyname: '',
        familyname: ''
      };
    },
    loadInit: function loadInit() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("checklogin");
      console.log(this.$store.state.user.permissions.user_add);
      console.log(this.$store.state.user.permissions.user_change);
      console.log(this.$route.params.user_id);
      if (typeof this.$route.params.user_id == 'undefined' && this.$store.state.user.permissions.user_add == 0) {
        this.showformular = false;
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Keine Berechtigung Benutzer anzulegen", 15);
        return;
      }
      if (this.$route.params.user_id > 0 && this.$store.state.user.permissions.user_change == 0) {
        this.showformular = false;
        __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Keine Berechtigung Benutzer zu ändern", 15);
        return;
      }

      this.$http.get('/api/getData.pl', { params: { data: ['select_member', 'select_security', 'users'] } }).then(function (response) {
        this.optionsMember = response.data.select_member;
        this.loadMember = false;
        this.optionsSecurity = response.data.select_security;
        this.loadSecurity = false;
        this.users = response.data.users;
      });

      if (this.$route.params.user_id > 0) {
        this.$store.state.heading = "Benutzer editieren";
        this.$store.state.isLoading = true;
        this.$http.get('/api/get_user.pl', { params: { user_id: this.$route.params.user_id } }).then(function (response) {
          this.currentUser = response.data.users;
          this.$store.state.isLoading = false;
          if (this.currentUser == 0) {
            this.showformular = false;
            __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Der Benutzer mit der ID " + this.$route.params.user_id + " existiert nicht", 0);
          } else {
            response.data.dberror ? __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined;
            this.validationCheck(this.validation, this.currentUser);
          }
        });
      } else {
        this.currentUser.passwordStatus = 1; // 0 = wird nicht geändert / 1 = wird generiert / 2 = wird eingegeben
        this.$store.state.heading = "Benutzer hinzufügen";
        this.validationCheck(this.validation, this.currentUser);
      }

      if (typeof this.$refs.loginname != 'undefined') {
        this.$nextTick(function () {
          return _this4.$refs.loginname.select();
        });
      }
    },
    editadd: function editadd(event) {
      var _this5 = this;

      this.validation.password.activ = this.currentUser.passwordStatus <= 1 ? false : true;

      // trim alle Strings in dem object currentUser
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentUser).map(function (k) {
        return _this5.currentUser[k] = typeof _this5.currentUser[k] == 'string' ? _this5.currentUser[k].trim() : _this5.currentUser[k];
      });

      var FormErrors = []; //this.validationCheck(this.validation, this.currentUser)
      FormErrors.length > 0 ? __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", FormErrors, 3) : undefined;
      if (FormErrors.length == 0) {
        if (this.users.find(function (x) {
          return x.value != _this5.currentUser.user_id && x.text.toUpperCase() === _this5.currentUser.loginname.toUpperCase();
        })) {
          __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Der Benutzername '" + this.currentUser.loginname + "' existiert schon, bitte einen anderen Benutzernamen eingeben.", 10);
        } else if (this.users.find(function (x) {
          return x.value != _this5.currentUser.user_id && x.email.toUpperCase() === _this5.currentUser.email.toUpperCase();
        })) {
          __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", "Die E-Mail Adresse '" + this.currentUser.email + "' gehört schon zu einem anderen Benutzer. Bitte eine andere E-Mail eingeben.", 10);
        } else {
          var headers = { 'Content-Type': 'application/json' };
          this.$http.post('/api/set_user.pl', { user: this.currentUser }, { headers: headers }).then(function (response) {
            var result = response.data;
            if (result.status == 0) {
              __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "error", result.error, 10);
            } else if (result.status == 2) {
              __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "info", result.info, 5);
            } else {
              if (result.newuserid > 0) {
                this.resetValues();
                this.loadInit();
                //this.$router.push({ name: 'editUser', params: { user_id: result.newuserid } })
              }
              __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$emit("showinfo", "success", result.info, 10);
            }
          });
        }
      }
    },
    btChangeToPasswordGenerate: function btChangeToPasswordGenerate(event) {
      this.currentUser.passwordStatus = 1;
    },
    btChangeToPasswortEnter: function btChangeToPasswortEnter(event) {
      this.currentUser.passwordStatus = 2;
    },
    btChangeToPasswortDontChange: function btChangeToPasswortDontChange(event) {
      if (this.$route.params.user_id > 0) {
        this.currentUser.passwordStatus = 0;
      }
    }
  },
  watch: {
    currentUser: {
      handler: function handler(val, oldVal) {
        var resultErrors = this.validationCheck(this.validation, val);
      },

      deep: true
    },
    '$route': function $route(to, from) {
      this.resetValues();
      this.loadInit();
    }
  },
  components: {}
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_functions__["a" /* default */]],
  data: function data() {
    return {};
  },

  created: function created() {
    this.resetBar();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    this.$store.state.heading = "Einstellungen";
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bus__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_functions__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'security',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_functions__["a" /* default */]],
  data: function data() {
    return {
      result: [],
      settings: {},
      fields: []
    };
  },

  created: function created() {
    this.resetBar();
    if (this.$store.state.user.permissions.security_add) {
      this.$store.state.bar.add = true;
    }
    this.$store.state.bar.search = true;
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
    this.$store.state.heading = "Sicherheit - Berechtigungsgruppen";

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("add", function (item) {
      if (item.length < 5) {
        __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "info", "Neue Benutzergruppe sollte mindestens 5 Zeichen haben", 5);
        return;
      }
      var headers = { 'Content-Type': 'application/json' };
      _this.$http.post('/api/security.pl', { action: "setNewSecurityGroup", group_name: item }, { headers: headers }).then(function (response) {
        if (response.data.status == 1) {
          __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("resetMenuInput");
          this.init();
        }
        __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", response.data.callmessage, response.data.message, response.data.timesecmessage);
      });
    });

    __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$on("changeSecurity", function (item, h) {
      var old_state = item[h.show];
      if (item[h.show] == 2) {
        return;
      }
      item[h.show] = 2;
      var words = h.show.split('_');
      if (words.length < 2) {
        return;
      }

      var headers = { 'Content-Type': 'application/json' };
      _this.$http.post('/api/security.pl', { action: "setSecurity", security_group_id: words[1], security_right_id: item.security_right_id }, { headers: headers }).then(function (response) {
        var result = response.data;
        if (result.status == 1) {
          item[h.show] = response.data.new_state;
          __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("checklogin");
        } else if (result.status == 2) {
          item[h.show] = old_state;
          __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "error", response.data.error, 10);
        } else {
          item[h.show] = old_state;
          __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10);
        }
      });
    });

    this.init();
  },
  methods: {
    init: function init() {
      if (this.$store.state.user.permissions.security_add) {
        this.$store.state.bar.menuinputplace = "Neue Benutzergruppe";
      }
      this.$store.state.isLoading = true;

      this.fields = [{ label: "Berechtigungen / Gruppen", show: "right_desc", width: "300px", sort: "sort_group" }, { label: "", show: "info", type: "info", sortable: false }];

      var headers = { 'Content-Type': 'application/json' };
      this.$http.post('/api/security.pl', { action: "getInit" }, { headers: headers }).then(function (response) {
        var result = response.data;
        if (result.status == 1) {
          this.securityGroups = response.data.security_groups;

          var self = this;
          this.securityGroups.forEach(function (item) {
            self.fields.push({
              label: item.text,
              show: "sg_" + item.value,
              classes: ["center", "nowrap", "button"],
              hclasses: ["rotate"],
              width: "60px",
              type: "check",
              event: "changeSecurity"
            });
          });

          this.result = response.data.result;
          this.$store.state.isLoading = false;
        } else {
          __WEBPACK_IMPORTED_MODULE_0__bus__["a" /* default */].$emit("showinfo", "error", "Es ist ein Fehler aufgetreten bei dem Laden der Rechte Gruppen", 10);
        }
      });
    }
  },
  components: {
    BaseTable: __WEBPACK_IMPORTED_MODULE_1__components_table_BaseTable__["a" /* default */]
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(218);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    user: { logged_in: 0 },
    heading: "",
    searchTerm: "",
    isLoading: false,
    development: false,
    bar: {},
    titlepostfix: " - TSV Kunreuth Adminbereich"
  }
}));

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_svg_core__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_semantic_ui_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_semantic_ui_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_semantic_ui_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_semantic_ui_vue___default.a);

__WEBPACK_IMPORTED_MODULE_5__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["r" /* faUser */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["m" /* faShieldAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["n" /* faSlidersH */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["s" /* faUserCog */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["o" /* faSms */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["c" /* faBars */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["g" /* faFileExcel */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["l" /* faPowerOff */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["p" /* faSpinner */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["a" /* faAngleLeft */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["b" /* faAngleRight */], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["b" /* faEdit */], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["e" /* faTrashAlt */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["d" /* faBirthdayCake */], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["c" /* faEye */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["k" /* faPlusSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["e" /* faCog */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["f" /* faFileAlt */], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["a" /* faCheckSquare */], __WEBPACK_IMPORTED_MODULE_7__fortawesome_free_regular_svg_icons__["d" /* faSquare */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["h" /* faInfo */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["j" /* faMercury */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["t" /* faVenus */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["i" /* faMars */], __WEBPACK_IMPORTED_MODULE_6__fortawesome_free_solid_svg_icons__["q" /* faSyncAlt */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('font-icon', __WEBPACK_IMPORTED_MODULE_8__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127332f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127332f3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"background",attrs:{"id":"background1"}}),_vm._v(" "),_c('div',{staticClass:"background",attrs:{"id":"background2"}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Admin__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Member__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_MemberEditNew__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SmsService__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Docs__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_User__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_UserEditNew__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Settings__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Security__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(99);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  linkExactActiveClass: 'is-active',
  routes: [{
    path: '/login/:status',
    name: 'loginstatus',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login__["a" /* default */],
    meta: { title: 'Login' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
  }, {
    path: '/login/:status/:regnummer/:user_id',
    name: 'loginregnummer',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login__["a" /* default */],
    meta: { title: 'Login' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login__["a" /* default */],
    meta: { title: 'Login' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
  }, {
    path: '/',
    name: 'admin',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Admin__["a" /* default */],
    meta: { title: 'Admin' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix },
    children: [{
      path: 'member',
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Member__["a" /* default */],
      meta: { title: 'Mitglieder' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'editMember/:member_id',
      name: 'editMember',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_MemberEditNew__["a" /* default */],
      meta: { title: 'Mitglied editieren' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix },
      props: true
    }, {
      path: 'newMember/',
      name: 'newMember',
      component: __WEBPACK_IMPORTED_MODULE_5__pages_MemberEditNew__["a" /* default */],
      meta: { title: 'Mitglied hinzufügen' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix },
      props: true
    }, {
      path: 'smsservice/:page_sms',
      name: 'smsservice',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_SmsService__["a" /* default */],
      meta: { title: 'SMS - Service' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'smsservice/',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_SmsService__["a" /* default */],
      meta: { title: 'SMS - Service' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'docs',
      component: __WEBPACK_IMPORTED_MODULE_7__pages_Docs__["a" /* default */],
      meta: { title: 'Dokumente' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'user',
      component: __WEBPACK_IMPORTED_MODULE_8__pages_User__["a" /* default */],
      meta: { title: 'Benutzer' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'editUser/:user_id',
      name: 'editUser',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_UserEditNew__["a" /* default */],
      meta: { title: 'Benutzer editieren' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix },
      props: true
    }, {
      path: 'newUser',
      name: 'newUser',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_UserEditNew__["a" /* default */],
      meta: { title: 'Benutzer hinzufügen' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix },
      props: true
    }, {
      path: 'settings',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_Settings__["a" /* default */],
      meta: { title: 'Einstellungen' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }, {
      path: 'security',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_Security__["a" /* default */],
      meta: { title: 'Sicherheit' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].state.titlepostfix }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 164 */,
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2646c147_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2646c147_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"wrap"},[_c('div',{attrs:{"id":"login"}},[_c('div',{attrs:{"id":"header"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 0),expression:"view == 0"}]},[_vm._v("\r\n      TSV Kunreuth Login\r\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 1),expression:"view == 1"}]},[_vm._v("\r\n      Neues Passwort setzten\r\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 2),expression:"view == 2"}]},[_vm._v("\r\n      TSV Kunreuth Login\r\n      ")])]),_vm._v(" "),_c('div',{class:_vm.classinfo,attrs:{"id":"info"}},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"right"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 2),expression:"view == 2"}],staticClass:"forgetPassword"},[_vm._m(1),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_email),expression:"user_email"}],ref:"user_email",attrs:{"tabindex":"2","type":"text","name":"user_email","placeholder":"E-Mail oder Benutzer","spellcheck":"false"},domProps:{"value":(_vm.user_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_email=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn senden",attrs:{"tabindex":"3"},on:{"click":_vm.forgetPasswordSend}},[_vm._v("SENDEN")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 1),expression:"view == 1"}],staticClass:"newpasswordform"},[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password1),expression:"password1"}],ref:"password1",attrs:{"tabindex":"1","type":"password","name":"password1","placeholder":"Passwort","spellcheck":"false"},domProps:{"value":(_vm.password1)},on:{"click":_vm.select,"input":function($event){if($event.target.composing){ return; }_vm.password1=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password2),expression:"password2"}],ref:"password2",attrs:{"tabindex":"2","type":"password","name":"password2","placeholder":"Passwort Wdh.","spellcheck":"false"},domProps:{"value":(_vm.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password2=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn senden",attrs:{"tabindex":"3"},on:{"click":_vm.passwordChange}},[_vm._v("SENDEN")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 0),expression:"view == 0"}],staticClass:"loginform"},[_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginname),expression:"loginname"}],ref:"loginname",attrs:{"tabindex":"1","type":"text","name":"loginname","placeholder":"Benutzer","spellcheck":"false"},domProps:{"value":(_vm.loginname)},on:{"keyup":_vm.keyup,"click":_vm.select,"input":function($event){if($event.target.composing){ return; }_vm.loginname=$event.target.value}}})]),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",attrs:{"tabindex":"2","type":"password","name":"password","placeholder":"Passwort","spellcheck":"false"},domProps:{"value":(_vm.password)},on:{"keyup":_vm.keyup,"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"link",on:{"click":_vm.forgetPassword}},[_vm._v("Benutzer oder Passwort vergessen?")])]),_vm._v(" "),_c('p',[_c('button',{staticClass:"btn anmelden",attrs:{"tabindex":"3"},on:{"click":_vm.login}},[_vm._v("ANMELDEN")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"left"}},[_c('img',{attrs:{"src":"/static/img/logo.png","width":"119","height":"148","alt":"TSV Kunreuth Verein Fussball"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"desc"},[_vm._v("E-Mail "),_c('strong',[_c('u',[_vm._v("oder")])]),_vm._v(" Benutzer eingeben um ein neues Passwort per E-Mail zu erhalten:")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_088a6c0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_088a6c0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ef8a1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(172);
function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39ef8a1c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"jhmenu"}},[_c('div',{staticClass:"topbar"},[_c('div',{staticClass:"left"},[_c('div',{attrs:{"id":"show-menu"},on:{"click":_vm.switchShow}},[_c('font-icon',{attrs:{"icon":"bars"}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$store.state.heading))])]),_vm._v(" "),_c('div',{staticClass:"right bar"},[(_vm.$store.state.bar.exportToExcel)?_c('button',{attrs:{"title":"Liste exportieren"},on:{"click":function($event){return _vm.clicked('exportToExcel')}}},[_c('font-icon',{attrs:{"icon":"file-excel"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.birthday)?_c('button',{attrs:{"title":"Geburtstage ausleiten"},on:{"click":function($event){return _vm.clicked('birthday')}}},[_c('font-icon',{attrs:{"icon":"birthday-cake"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.view)?_c('button',{attrs:{"title":"Sicht �ndern"},on:{"click":function($event){return _vm.clicked('view')}}},[_c('font-icon',{attrs:{"icon":['far', 'eye']}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.setting)?_c('button',{attrs:{"title":"Einstellungen"},on:{"click":function($event){return _vm.clicked('setting')}}},[_c('font-icon',{attrs:{"icon":"cog"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.refresh)?_c('button',{attrs:{"title":"Aktualisieren"},on:{"click":function($event){return _vm.clicked('refresh')}}},[_c('font-icon',{attrs:{"icon":"sync-alt"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.menuinputplace)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.menuinput),expression:"menuinput"}],staticClass:"menuinput",attrs:{"placeholder":_vm.$store.state.bar.menuinputplace,"type":"text"},domProps:{"value":(_vm.menuinput)},on:{"input":function($event){if($event.target.composing){ return; }_vm.menuinput=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.add)?_c('button',{attrs:{"title":"Hinzuf�gen"},on:{"click":function($event){return _vm.clicked('add', _vm.menuinput)}}},[_c('font-icon',{attrs:{"icon":"plus-square"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.bar.search)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$store.state.searchTerm),expression:"$store.state.searchTerm"}],staticClass:"search",attrs:{"placeholder":"Suche","type":"search"},domProps:{"value":(_vm.$store.state.searchTerm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.$store.state, "searchTerm", $event.target.value)}}}):_vm._e()])]),_vm._v(" "),_c('ul',{class:_vm.classLeftBar,on:{"mouseover":_vm.mouseOverLeftBar,"mouseleave":_vm.mouseLeaveLeftBar}},[_c('li',[_c('router-link',{class:_vm.$store.state.user.permissions.member_show ? '' : 'disabled',attrs:{"to":"/member","event":_vm.$store.state.user.permissions.member_show ? 'click' : ''}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"user"}})],1),_vm._v(" "),_c('span',[_vm._v("Mitglieder")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:_vm.$store.state.user.permissions.dokumente_show ? '' : 'disabled',attrs:{"to":"/docs","event":_vm.$store.state.user.permissions.dokumente_show ? 'click' : ''}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"file-alt"}})],1),_vm._v(" "),_c('span',[_vm._v("Dokumente")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:_vm.$store.state.user.permissions.sms_show ? '' : 'disabled',attrs:{"to":"/smsservice","event":_vm.$store.state.user.permissions.sms_show ? 'click' : ''}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"sms"}})],1),_vm._v(" "),_c('span',[_vm._v("SMS-Service")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:_vm.$store.state.user.permissions.user_show ? '' : 'disabled',attrs:{"to":"/user","event":_vm.$store.state.user.permissions.user_show ? 'click' : ''}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"user-cog"}})],1),_vm._v(" "),_c('span',[_vm._v("Benutzer")])])],1),_vm._v(" "),_c('li',[_c('router-link',{class:_vm.$store.state.user.permissions.security_show ? '' : 'disabled',attrs:{"to":"/security","event":_vm.$store.state.user.permissions.security_show ? 'click' : ''}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"shield-alt"}})],1),_vm._v(" "),_c('span',[_vm._v("Sicherheit")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/profil"}},[_c('div',{staticClass:"icon"},[_c('div',{staticClass:"dot"},[_vm._v(_vm._s(_vm.shortProfilName))])]),_vm._v(" "),_c('span',[_vm._v("Profil")])])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.clicked('logout')}}},[_c('div',{staticClass:"icon"},[_c('font-icon',{attrs:{"icon":"power-off"}})],1),_vm._v(" "),_c('span',[_vm._v("Logout")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.classinfoStyle,attrs:{"id":"infoundermenu"}},[(_vm.infoTextList.length > 0)?_c('div',[_c('i',{staticClass:"close icon",on:{"click":_vm.closeInfoShow}}),_vm._v(" "),_c('ul',_vm._l((_vm.infoTextList),function(item,i){return _c('li',{key:i},[_vm._v("\n          "+_vm._s(item)+"\n        ")])}),0)]):_c('div',[_c('i',{staticClass:"close icon",on:{"click":_vm.closeInfoShow}}),_vm._v("\n      "+_vm._s(_vm.infoText))])]),_vm._v(" "),(_vm.$store.state.isLoading == true)?_c('div',{attrs:{"id":"isLoading"}},[_c('div',[_c('p',[_c('font-icon',{attrs:{"icon":"spinner","spin":""}})],1),_vm._v(" "),_c('p',[_vm._v("Daten werden geladen. Bitte warten...")])])]):_vm._e(),_vm._v(" "),(_vm.$store.state.user.logged_in == 1)?_c('div',{staticClass:"admin"},[_c('JHMenu'),_vm._v(" "),_c('router-view')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Member_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af6541e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Member_vue__ = __webpack_require__(191);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Member_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af6541e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Member_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTablePagination_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efbeb7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTablePagination_vue__ = __webpack_require__(189);
function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4efbeb7c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BaseTablePagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efbeb7c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BaseTablePagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowPagination)?_c('nav',{staticClass:"my-pagination"},[_c('p',{staticClass:"descleft"},[_vm._v(_vm._s(_vm.von)+" bis "+_vm._s(_vm.bis)+" von "+_vm._s(_vm.pagination.totalItems)+" Einträge")]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v("Seite "+_vm._s(_vm.pagination.currentPage)+" von "+_vm._s(_vm.pagination.totalPages))]),_vm._v(" "),_c('ul',{staticClass:"pagination justify-content-left"},[_c('li',{class:{ disabled: _vm.pagination.currentPage === 1 }},[_c('a',{staticClass:"page-link",class:{ disabled: _vm.pagination.currentPage === 1 },on:{"click":function($event){return _vm.pageClicked( _vm.pagination.currentPage - 1 )},"mousedown":function($event){return _vm.pageMouseDown( '-' )},"mouseup":function($event){return _vm.pageMouseUp()}}},[_c('font-icon',{staticStyle:{"margin":"0 6px 0 0"},attrs:{"icon":"angle-left","size":"lg"}}),_vm._v(" ZURÜCK\n            ")],1)]),_vm._v(" "),(_vm.hasFirst)?_c('li',{staticClass:"page-item",class:{ active: _vm.isActive(1) }},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.pageClicked(1)}}},[_vm._v("1")])]):_vm._e(),_vm._v(" "),(_vm.hasFirstEllipsis)?_c('li',[_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pages),function(page){return _c('li',{key:page,staticClass:"page-item",class:{ active: _vm.isActive(page), disabled: page === '...' }},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.pageClicked(page)}}},[_vm._v(_vm._s(page))])])}),_vm._v(" "),(_vm.hasLastEllipsis)?_c('li',[_c('span',{staticClass:"pagination-ellipsis"},[_vm._v("…")])]):_vm._e(),_vm._v(" "),(_vm.hasLast)?_c('li',{staticClass:"page-item",class:{ active: _vm.isActive(this.pagination.totalPages) }},[_c('a',{staticClass:"page-link",on:{"click":function($event){return _vm.pageClicked(_vm.pagination.totalPages)}}},[_vm._v(_vm._s(_vm.pagination.totalPages))])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{staticClass:"page-link",class:{ disabled: _vm.pagination.currentPage === _vm.pagination.totalPages },on:{"click":function($event){return _vm.pageClicked( _vm.pagination.currentPage + 1 )},"mousedown":function($event){return _vm.pageMouseDown( '+' )},"mouseup":function($event){return _vm.pageMouseUp()}}},[_vm._v("VOR "),_c('font-icon',{staticStyle:{"margin":"0 0 0 6px"},attrs:{"icon":"angle-right","size":"lg"}})],1)])],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.isLoading == false)?_c('div',{class:_vm.wrapTableClasses},[(_vm.settings.development == true)?_c('b-button',{on:{"click":function($event){return _vm.test()}}},[_vm._v("TEST")]):_vm._e(),_vm._v(" "),(_vm.settings.searchinput == true)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTermIntern),expression:"searchTermIntern"}],staticClass:"search",attrs:{"type":"text","placeholder":"Suche"},domProps:{"value":(_vm.searchTermIntern)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTermIntern=$event.target.value}}}):_vm._e(),_vm._v(" "),_c('table',{staticClass:"reportTable",class:_vm.tableClasses},[_c('thead',[_c('tr',_vm._l((_vm.displayedFields),function(h,i){return _c('th',{key:i,class:h.hclasses,attrs:{"width":h.width}},[(_vm.hasClass(h.hclasses,'rotate'))?_c('div',{style:({ width: h.width })},[_c('span',[_vm._v(_vm._s(h.label))])]):_c('div',[(typeof h.sortable !== 'undefined' || h.sortable)?_c('div',[_c('span',[_vm._v(_vm._s(h.label))])]):(h.type != 'button')?_c('div',{staticClass:"label sortable",class:[ h.isFiltered == true ? 'isFiltered' : '' ],on:{"click":function($event){return _vm.orderBy(h)}}},[_c('span',[_vm._v(_vm._s(h.label))])]):_vm._e(),_vm._v(" "),(_vm.sort.fieldName === h.show && (typeof h.sortable === 'undefined' || !h.sortable) )?_c('div',{staticClass:"sortdiv"},[_c('span',{class:_vm.sort.order})]):_vm._e()])])}),0)]),_vm._v(" "),_c('tbody',[(_vm.displayedRows.length == 0)?_c('tr',{staticClass:"no-data"},[_c('td',{attrs:{"colspan":_vm.displayedFields.length}},[_vm._v("Keine Daten vorhanden")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.displayedRows),function(b,i){return _c('tr',{key:i},_vm._l((_vm.displayedFields),function(h,j){return _c('td',{key:j,class:_vm.colclasses(h, b)},[(h.type == 'button')?_c('div',{attrs:{"title":h.show},on:{"click":function($event){return _vm.clicked(h.event, b)}}},[(h.icon)?_c('font-icon',{class:h.classes,attrs:{"icon":h.icon}}):_vm._e()],1):(h.type == 'check')?_c('div',{class:h.classes,on:{"click":function($event){return _vm.clicked(h.event, b, h)}}},[(b[h.show] == 1)?_c('font-icon',{staticClass:"check",attrs:{"icon":['far', 'check-square']}}):(b[h.show] == 0)?_c('font-icon',{staticClass:"notcheck",attrs:{"icon":['far', 'square']}}):_c('font-icon',{staticClass:"check_load",attrs:{"icon":"spinner","spin":""}})],1):(h.iconcolname)?_c('span',[(b[h.iconcolname].length > 0)?_c('font-icon',{class:h.classes,style:({ fill: h.fillcolor }),attrs:{"icon":b[h.iconcolname]}}):_vm._e()],1):(h.type == 'info')?_c('span',{staticClass:"info",attrs:{"title":b[h.show]}},[_c('font-icon',{class:h.classes,attrs:{"icon":['fa', 'info']}})],1):(h.type == 'title')?_c('span',{staticClass:"c",attrs:{"title":b[h.title]},domProps:{"innerHTML":_vm._s(_vm.highlight(b[h.show], _vm.searchTermIntern))}},[_vm._v(_vm._s(b[h.show]))]):_c('span',{staticClass:"c",attrs:{"title":b[h.show]},domProps:{"innerHTML":_vm._s(_vm.highlight(b[h.show], _vm.searchTermIntern))}},[_vm._v(_vm._s(b[h.show]))])])}),0)})],2)]),_vm._v(" "),(_vm.pagination)?_c('pagination',{attrs:{"pagination":_vm.pagination},on:{"pageChange":_vm.pageChange}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"sortBy":"familyname","sortOrder":"asc","rowClass":"familyname","tableId":"1"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberEditNew_vue__ = __webpack_require__(92);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0a10ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberEditNew_vue__ = __webpack_require__(194);
function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MemberEditNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a0a10ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MemberEditNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.isLoading == false)?_c('div',{staticClass:"membereditnew formular"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('p',[_vm._v("Benutzerdaten")]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('label',{attrs:{"for":"loginname"}},[_vm._v("Benutzername:")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"loginname","spellcheck":"false"}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"password"}},[_vm._v("Passwort:")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"password","spellcheck":"false"}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"email"}},[_vm._v("E-Mail Adresse:")]),_vm._v(" "),_c('input',{attrs:{"type":"email","id":"email","spellcheck":"false"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-container"},[_c('p',[_vm._v("Persönliche Daten")]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('label',{attrs:{"for":"prename"}},[_vm._v("Vorname:")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"prename","spellcheck":"false"}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"familyname"}},[_vm._v("Nachname:")]),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"familyname","spellcheck":"false"}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"familyname"}},[_vm._v("Multiselect:")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsService_vue__ = __webpack_require__(93);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5a415e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsService_vue__ = __webpack_require__(197);
function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsService_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd5a415e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsService_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.sms_show)?_c('div',{staticClass:"smsservice"},[_c('div',{staticClass:"ui secondary pointing menu"},[_c('router-link',{staticClass:"item",attrs:{"to":"/smsservice/0"}},[_vm._v("Rund-SMS verschicken")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":"/smsservice/1"}},[_vm._v(_vm._s(_vm.menuDescAnmeldungen))]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":"/smsservice/2"}},[_vm._v("Gesendet")]),_vm._v(" "),_c('router-link',{staticClass:"item",attrs:{"to":"/smsservice/3"}},[_vm._v("Empfangen")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.isLoading == false),expression:"$store.state.isLoading == false"}],staticClass:"wrapcontent"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active == 0),expression:"active == 0"}],staticClass:"wrapsmssend"},[_c('div',{staticClass:"sendsms"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.smscontent),expression:"smscontent"}],ref:"smstextarea",staticClass:"smstextarea",attrs:{"cols":"60","rows":"15","autocomplete":"off"},domProps:{"value":(_vm.smscontent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.smscontent=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn smssend",attrs:{"tabindex":"15"},on:{"click":_vm.smssend}},[_vm._v("SMS versenden"),_c('div',{staticClass:"anzahlzeichen"},[_vm._v(_vm._s(_vm.anzahlzeichen))])]),_vm._v(" "),_vm._l((_vm.smscontentarray),function(sms,i){return _c('div',{key:i,staticClass:"sms_preview"},[_c('p',[_vm._v(_vm._s(sms))])])})],2),_vm._v(" "),_c('sui-form',[_c('sui-form-fields',{attrs:{"grouped":""}},[_c('sui-form-field',{staticClass:"first"},[_c('sui-checkbox',{attrs:{"label":"An Alle","radio":"","value":"0","disabled":!_vm.$store.state.user.permissions.sms_send_all},model:{value:(_vm.abteilung),callback:function ($$v) {_vm.abteilung=$$v},expression:"abteilung"}})],1),_vm._v(" "),_c('sui-form-field',[_c('sui-checkbox',{attrs:{"label":"Abt. Fußball","radio":"","value":"fussball","disabled":!_vm.$store.state.user.permissions.sms_send_fussball},model:{value:(_vm.abteilung),callback:function ($$v) {_vm.abteilung=$$v},expression:"abteilung"}})],1),_vm._v(" "),_c('sui-form-field',[_c('sui-checkbox',{attrs:{"label":"Abt. Tennis","radio":"","value":"tennis","disabled":!_vm.$store.state.user.permissions.sms_send_tennis},model:{value:(_vm.abteilung),callback:function ($$v) {_vm.abteilung=$$v},expression:"abteilung"}})],1),_vm._v(" "),_c('sui-form-field',[_c('sui-checkbox',{attrs:{"label":"Abt. Volleyball","radio":"","value":"vollyball","disabled":!_vm.$store.state.user.permissions.sms_send_vollyball},model:{value:(_vm.abteilung),callback:function ($$v) {_vm.abteilung=$$v},expression:"abteilung"}})],1),_vm._v(" "),_c('sui-form-field',[_c('sui-checkbox',{attrs:{"label":"Abt. Gymnastik","radio":"","value":"gym","disabled":!_vm.$store.state.user.permissions.sms_send_gym},model:{value:(_vm.abteilung),callback:function ($$v) {_vm.abteilung=$$v},expression:"abteilung"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active == 1),expression:"active == 1"}]},[_c('BaseTable',{attrs:{"settings":_vm.settings_anmeldungen,"fields":_vm.fields_anmeldungen,"items":_vm.sms_anmeldungen,"searchTerm":_vm.$store.state.searchTerm,"colstripes":"","bordered":false,"tableClass":"tableAnmeldungen","sortBy":"start","sortOrder":"desc","tableId":"1"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active == 2),expression:"active == 2"}]},[_c('BaseTable',{attrs:{"settings":_vm.settings_gesendet,"fields":_vm.fields_gesendet,"items":_vm.sms_gesendet,"searchTerm":_vm.$store.state.searchTerm,"bordered":false,"colstripes":"","tableClass":"tableGesendet","sortBy":"send_datetime","sortOrder":"desc","tableId":"2"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active == 3),expression:"active == 3"}]},[_c('BaseTable',{attrs:{"settings":_vm.settings_empfangen,"fields":_vm.fields_empfangen,"items":_vm.sms_empfangen,"searchTerm":_vm.$store.state.searchTerm,"bordered":false,"tableClass":"tableEmpfangen","sortBy":"receive_datetime","sortOrder":"desc","tableId":"3"}})],1)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1e66b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__ = __webpack_require__(200);
function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1e66b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"docs"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1e3e942_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(203);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1e3e942_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.user_show)?_c('div',{staticClass:"user"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"sortBy":"familyname","sortOrder":"desc","rowClass":"familyname","tableId":"1"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEditNew_vue__ = __webpack_require__(96);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a35145ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEditNew_vue__ = __webpack_require__(211);
function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a35145ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserEditNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a35145ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserEditNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    validationCheck: function validationCheck(validationData, data) {
      var ReturnValueErrors = [];
      var rexMinLength = /minLength\[(\d+)\](.*)/gi;

      for (var validation in validationData) {

        // Wenn es nicht aktiv ist dann wird es nicht beachtet
        if (typeof validationData[validation].activ != 'undefined' && validationData[validation].activ == false) {
          continue;
        }

        // Hier wird die Länge des Feldinhalts überprüft
        var minLengthMatch = rexMinLength.exec(validationData[validation].type);
        if (minLengthMatch) {
          var minLength = minLengthMatch[1];

          if (typeof data[validation] != 'undefined' && data[validation].length >= minLength) {
            validationData[validation].class = "";
            if (minLengthMatch.length == 3 && typeof validationData[validation].compareField != 'undefined' && validationData[validation].compareField != '' && minLengthMatch[2] === "password") {
              if (data[validation] !== data[validationData[validation].compareField]) {
                validationData[validation].class = "error";
                ReturnValueErrors.push(validationData[validation].prompt2);
              }
            }
          } else {
            validationData[validation].class = "error";
            ReturnValueErrors.push(validationData[validation].prompt);
          }
          continue;
        }

        // Hier wird ein Select Feld überprüft ob die ID größer 0 ist
        if (validationData[validation].type === 'selectionNot0') {
          if (typeof data[validation] != 'undefined' && data[validation] > 0) {
            validationData[validation].class = "";
          } else {
            validationData[validation].class = "error";
            ReturnValueErrors.push(validationData[validation].prompt);
          }
          continue;
        }

        // Mittels einer Regex wird überprüft ob dies eine E-Mail Adresse ist
        var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (validationData[validation].type === 'email') {
          if (typeof data[validation] != 'undefined' && data[validation].length > 0) {
            var emailValidate = data[validation].match(reEmail);
            if (emailValidate) {
              validationData[validation].class = "";
            } else {
              validationData[validation].class = "error";
              ReturnValueErrors.push(validationData[validation].prompt);
            }
          } else {
            validationData[validation].class = "error";
            ReturnValueErrors.push(validationData[validation].promptEmpty);
          }
          continue;
        }
      }
      return ReturnValueErrors;
    }

  },
  mounted: function mounted() {}
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.isLoading == false && _vm.showformular),expression:"$store.state.isLoading == false && showformular"}],staticClass:"usereditnew formular"},[_c('div',{staticClass:"form-container"},[_c('p',[_vm._v("Benutzerdaten")]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',{class:_vm.validation.loginname.class},[_c('label',{attrs:{"for":"loginname"}},[_vm._v("Benutzername:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.loginname),expression:"currentUser.loginname"}],ref:"loginname",attrs:{"type":"text","tabindex":"1","id":"loginname","spellcheck":"false","autocomplete":"new-password"},domProps:{"value":(_vm.currentUser.loginname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "loginname", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUser.passwordStatus == 1),expression:"currentUser.passwordStatus == 1"}],staticClass:"generate_password"},[(_vm.$route.params.user_id > 0)?_c('button',{staticClass:"btn bt_generate_password",attrs:{"tabindex":"2","title":"Passwort nicht ändern"},on:{"click":_vm.btChangeToPasswortDontChange}},[_c('i',{staticClass:"close icon"})]):_c('button',{staticClass:"btn bt_dont_change_password",attrs:{"tabindex":"2","title":"Passwort selbst vergeben"},on:{"click":_vm.btChangeToPasswortEnter}},[_c('i',{staticClass:"edit icon"})]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('label',[_vm._v("Passwort:")]),_vm._v(" "),_c('div',[_c('input',{ref:"generate_password",staticClass:"disabledCenter",attrs:{"type":"text","tabindex":"3","id":"generate_password","spellcheck":"false","value":"WIRD GENERIERT","readonly":""}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUser.passwordStatus == 0),expression:"currentUser.passwordStatus == 0"}],staticClass:"dont_change_password"},[_c('button',{staticClass:"btn bt_dont_change_password",attrs:{"tabindex":"4","title":"Passwort selbst vergeben"},on:{"click":_vm.btChangeToPasswortEnter}},[_c('i',{staticClass:"edit icon"})]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('label',[_vm._v("Passwort:")]),_vm._v(" "),_c('div',[_c('input',{ref:"dont_change_password",staticClass:"disabledCenter",attrs:{"type":"text","tabindex":"5","id":"dont_change_password","spellcheck":"false","value":"WIRD NICHT GEÄNDERT","readonly":""}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUser.passwordStatus == 2),expression:"currentUser.passwordStatus == 2"}],staticClass:"enter_password"},[_c('button',{staticClass:"btn bt_change_to_password_generate",attrs:{"tabindex":"6","title":"Passwort wird generiert"},on:{"click":_vm.btChangeToPasswordGenerate}},[_c('i',{staticClass:"magic icon"})]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',{class:_vm.validation.password.class},[_c('label',{attrs:{"for":"password"}},[_vm._v("Passwort:")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.password),expression:"currentUser.password"}],ref:"password",attrs:{"type":"password","tabindex":"7","id":"password","spellcheck":"false","autocomplete":"new-password"},domProps:{"value":(_vm.currentUser.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "password", $event.target.value)}}})])]),_vm._v(" "),_c('li',{class:_vm.validation.password.class},[_c('label',{attrs:{"for":"password_wdh"}},[_vm._v("Passwort (Wdh.):")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.password_wdh),expression:"currentUser.password_wdh"}],ref:"password_wdh",attrs:{"type":"password","tabindex":"8","id":"password_wdh","spellcheck":"false","autocomplete":"new-password"},domProps:{"value":(_vm.currentUser.password_wdh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "password_wdh", $event.target.value)}}})])])])]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',{class:_vm.validation.email.class},[_c('label',{attrs:{"for":"email"}},[_vm._v("E-Mail Adresse:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentUser.email),expression:"currentUser.email"}],ref:"email",attrs:{"type":"email","tabindex":"9","id":"email","spellcheck":"false"},domProps:{"value":(_vm.currentUser.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.currentUser, "email", $event.target.value)}}})]),_vm._v(" "),_c('li',{class:_vm.validation.security_group.class},[_c('label',{attrs:{"for":"security_group"}},[_vm._v("Benutzergruppe:")]),_vm._v(" "),_c('sui-dropdown',{attrs:{"options":_vm.optionsSecurity,"placeholder":"- Bitte auswählen -","search":"","selection":"","tabindex":"10","loading":_vm.loadSecurity,"noResultsMessage":"Kein Ergebnis gefunden"},model:{value:(_vm.currentUser.security_group),callback:function ($$v) {_vm.$set(_vm.currentUser, "security_group", $$v)},expression:"currentUser.security_group"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-container"},[_c('p',[_vm._v("Persönliche Daten")]),_vm._v(" "),_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('label',{attrs:{"for":"prename"}},[_vm._v("Vorname:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.prename),expression:"prename"}],ref:"prename",class:_vm.prenameFamilynameClass,attrs:{"type":"text","tabindex":"11","id":"prename","spellcheck":"false","readonly":_vm.Checkreadonly},domProps:{"value":(_vm.prename)},on:{"input":function($event){if($event.target.composing){ return; }_vm.prename=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"familyname"}},[_vm._v("Nachname:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.familyname),expression:"familyname"}],ref:"familyname",class:_vm.prenameFamilynameClass,attrs:{"type":"text","tabindex":"12","id":"familyname","spellcheck":"false","readonly":_vm.Checkreadonly},domProps:{"value":(_vm.familyname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.familyname=$event.target.value}}})]),_vm._v(" "),_c('li',[_c('label',{attrs:{"for":"memberSelected"}},[_vm._v("Mitglied:")]),_vm._v(" "),_c('sui-dropdown',{attrs:{"options":_vm.optionsMember,"placeholder":"- Bitte auswählen -","search":"","selection":"","tabindex":"13","loading":_vm.loadMember,"noResultsMessage":"Kein Ergebnis gefunden"},model:{value:(_vm.currentUser.member_id),callback:function ($$v) {_vm.$set(_vm.currentUser, "member_id", $$v)},expression:"currentUser.member_id"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-container"},[_c('ul',{staticClass:"flex-outer"},[_c('li',[_c('button',{staticClass:"btn editadd",attrs:{"tabindex":"15"},on:{"click":_vm.editadd}},[_vm._v("SPEICHERN")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31eade62_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31eade62_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20252059_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__ = __webpack_require__(217);
function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20252059_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.security_show)?_c('div',{staticClass:"security"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"colstripes":"","tableClass":"tableSecurity","sortBy":"right_desc","sortOrder":"asc","tableId":"1"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[156]);


// WEBPACK FOOTER //
// static/js/app.75993fbe803f793e3612.js